import { Element } from "@siteimprove/alfa-dom";
import { WithIndex } from "./pseudo-class.js";
const { hasName, isElement } = Element;
/**
 * {@link https://drafts.csswg.org/selectors/#nth-of-type-pseudo}
 */
export class NthOfType extends WithIndex {
    static of(index) {
        return new NthOfType(index);
    }
    constructor(index) {
        super("nth-of-type", index);
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element) {
        const indices = NthOfType._indices;
        if (!indices.has(element)) {
            element
                .inclusiveSiblings()
                .filter(isElement)
                .filter(hasName(element.name))
                .forEach((element, i) => {
                indices.set(element, i + 1);
            });
        }
        return this._index.matches(indices.get(element));
    }
    equals(value) {
        return value instanceof NthOfType && value._index.equals(this._index);
    }
    toJSON() {
        return {
            ...super.toJSON(),
        };
    }
}
(function (NthOfType) {
    NthOfType.parse = WithIndex.parseWithIndex("nth-of-type", NthOfType.of);
})(NthOfType || (NthOfType = {}));
//# sourceMappingURL=nth-of-type.js.map